import { useEffect } from 'react';
import { useAllocation } from '../../hooks/useAllocation';
import { browserLogger } from '../../utils/loggers/browser';

/**
 * Login SSO Order Experiment:
 * https://signal.daylight.stitchfix.com/experiments/1813
 */

export const LOGIN_SSO_ORDER_CONFIG_PARAM_NAME = 'eng.onboarding.login_sso_order' as const;
const LOGIN_SSO_ORDER_CONTROL = 'control' as const;
const LOGIN_SSO_ORDER_TREATMENT = 'treatment' as const;
export const useLoginSSOOrderAllocation = () => {
  const {
    data,
    loading,
    error
  } = useAllocation([{
    expectedValues: [LOGIN_SSO_ORDER_CONTROL, LOGIN_SSO_ORDER_TREATMENT],
    fallbackValue: LOGIN_SSO_ORDER_CONTROL,
    name: LOGIN_SSO_ORDER_CONFIG_PARAM_NAME
  }]);
  const allocationValue = data?.visitor?.configParams?.find(configParam => configParam.name === LOGIN_SSO_ORDER_CONFIG_PARAM_NAME)?.value;
  useEffect(() => {
    if (!error) return;
    browserLogger({
      level: 'error',
      team: 'client-onboarding',
      feature: 'registration',
      message: '[Login SSO Order] Failed to allocate visitor to experiment',
      error
    });
  }, [error]);
  return {
    allocationLoading: loading,
    isTreatment: allocationValue === LOGIN_SSO_ORDER_TREATMENT
  };
};